import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { ToastrService } from 'ngx-toastr';
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { isPlatformBrowser } from "@angular/common";
import { secureStorage } from "../services/encryption/secureservice";
import { RootService } from "../services/root.service";

@Injectable({
    providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {
    isLoggedIn: boolean = false;
    constructor(private toaster: ToastrService, private spinner: NgxSpinnerService,

        private localStorage: secureStorage,
        @Inject(PLATFORM_ID) private platformId: Object, private storageService: RootService,) { }
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                // this.authenticationService.logout();
                this.spinner.hide()
                if (isPlatformBrowser(this.platformId)) {

                    this.isLoggedIn = this.storageService.isLoggedIn() ? true : false;
                    if (this.isLoggedIn) {
                        this.storageService.refreshToken();
                    }
                    else {
                        if (this.localStorage.getItem('FreeRefreshTokenInProgress') != 'true') {
                            this.localStorage.setItem('FreeRefreshTokenInProgress', 'true');
                            this.storageService.getFreeSearchToken(true);
                        }
                    }
                }
            }
            else if (err.status === 500) {
                this.toaster.warning("Server Error , Please Try Again.")
                this.spinner.hide()
            }
            else if (err.status === 503) {
                this.toaster.warning("Server Error , Please Try Again.")
                this.spinner.hide()
            }
            else if (err.status === 504) {
                this.toaster.warning('Slow internet connection.\n Please try again after sometime.')
                this.spinner.hide()
            }
            else if (err.status === 422) {
                //   // use in duplicate promotion ID
                this.toaster.warning(err.error.message)
                this.spinner.hide()
            }
            else if (err.status === 400) {
                this.toaster.warning(err.error.message)
                this.spinner.hide()
            }
            else if (err.status === 412) {
                var baseurl = window.location.href;
                if ((err?.error?.data?.msg == "Mobile number already exists.") && (baseurl.includes('/finance-offers'))) {
                    return
                }
                if (err?.error?.detail == "Request was throttled.") {
                    this.toaster.warning("Your account is locked due to multiple incorrect attempts, \n Please try after some time.")
                }
                if (err?.error?.msg == "You have reached maximum attempts. Kindly try after 60 seconds.") {
                    this.toaster.warning("Your account is locked due to multiple incorrect attempts, \n Please try after some time.")
                }
                // this.toaster.warning(err?.error?.data?.msg || err?.detail || err?.error?.detail)
                this.spinner.hide()
            }
            const error = err?.error?.message || err?.statusText || err?.error?.detail || err?.error?.msg;
            return throwError(error);
        }));
    }

}
